import type React from "react";
import { useState } from "react";
import { Box } from "@radix-ui/themes";
import { OptimizedImage } from "~/components/OptimizedImage";

interface HoverRevealImagesProps {
  topImage: string; // URL for the top image
  bottomImage: string; // URL for the bottom image
  alt?: string;
  style?: React.CSSProperties;
  className?: string;
  fill?: boolean;
}

export const HoverRevealImages: React.FC<HoverRevealImagesProps> = ({
  topImage,
  bottomImage,
  alt = "",
  style,
  className,
  fill = false,
}) => {
  const [hover, setHover] = useState<boolean>(false);
  const imageSizing: React.CSSProperties = fill
    ? {
        width: "100%",
        height: "100%",
        objectFit: "cover",
      }
    : {
        width: "100%",
        height: "auto",
        minHeight: "auto",
        objectFit: "cover",
      };

  return (
    <Box
      className={className}
      style={{
        position: "relative",
        overflow: "hidden",
        ...style,
      }}
    >
      {/* Bottom Image */}
      <OptimizedImage
        src={bottomImage}
        alt={alt}
        style={{
          ...imageSizing,
          display: "block",
        }}
      />

      {/* Top Image */}
      <OptimizedImage
        src={topImage}
        alt={alt}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          ...imageSizing,
          display: "block",
          opacity: hover ? 0 : 1,
          transition: "opacity 0.33s ease",
        }}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      />
    </Box>
  );
};
